import { createContext, useContext, useState, ReactNode, Dispatch, SetStateAction } from "react";

interface UnityActionsContextType {
  modelDensity: number | null;
  setModelDensity: Dispatch<SetStateAction<number | null>>;
  show3DModel: boolean;
  setShow3DModel: Dispatch<SetStateAction<boolean>>;
  editingMode: boolean;
  setEditingMode: Dispatch<SetStateAction<boolean>>;
  cameraMode: boolean;
  setCameraMode: Dispatch<SetStateAction<boolean>>;
  idleCameraMode: boolean;
  setIdleCameraMode: Dispatch<SetStateAction<boolean>>;
  widgetSwitch: boolean;
  setWidgetSwitch: Dispatch<SetStateAction<boolean>>;
}

const UnityActionsContext = createContext<UnityActionsContextType | undefined>(undefined);

export const UnityActionsProvider = ({ children }: { children: ReactNode }) => {
  const [modelDensity, setModelDensity] = useState<number | null>(1);
  const [show3DModel, setShow3DModel] = useState(false);
  const [editingMode, setEditingMode] = useState(false);
  const [cameraMode, setCameraMode] = useState(true);
  const [idleCameraMode, setIdleCameraMode] = useState(false);
  const [widgetSwitch, setWidgetSwitch] = useState(true);

  return (
    <UnityActionsContext.Provider value={{
      modelDensity, setModelDensity,
      show3DModel, setShow3DModel,
      editingMode, setEditingMode,
      cameraMode, setCameraMode,
      idleCameraMode, setIdleCameraMode,
      widgetSwitch, setWidgetSwitch
    }}>
      {children}
    </UnityActionsContext.Provider>
  );
};

export const useUnityActions = () => {
  const context = useContext(UnityActionsContext);
  if (!context) {
    throw new Error("useUnityActions must be used within a UnityActionsProvider");
  }
  return context;
};
